import React, {useEffect, useState} from "react";
import axios from "axios";
import TourDetailsNew from "../TourDetails/TourDetailsNew";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import s from "./ComboDetails.module.scss";
import titleImage from '../../assets/images/titleImage.png';
import {useParams} from "react-router-dom";

export default function ComboDetails() {
    const {id} = useParams();
    const apiUrl = process.env.REACT_APP_API_URL;

    const [combo, setCombo] = useState(null);
    const [activeTour, setActiveTour] = useState(null);
    const [cartItems, setCartItems] = useState([]);


    useEffect(() => {
        loadCombo();
    }, [id]);
    useEffect(() => {
        const loadCart = () => {
            const cart = JSON.parse(
                localStorage.getItem("booking_cart") || "[]"
            );
            setCartItems(cart);
        };

        loadCart();

        window.addEventListener("cartUpdated", loadCart);

        return () => {
            window.removeEventListener("cartUpdated", loadCart);
        };
    }, []);
    const breadcrumbItems = [
        {name: 'ホーム', link: '/'},
        {name: combo?.name && ""},
    ];
    const loadCombo = async () => {
        const res = await axios.get(
            `${apiUrl}/api/combo-offers/${id}`
        );

        setCombo(res.data);

        if (res.data.tours?.length > 0) {
            setActiveTour(res.data.tours[0]);
        }
    };
    const handleNextTour = (nextTour) => {
        if (nextTour) {
            setActiveTour(nextTour);
            window.scrollTo({top: 0, behavior: "smooth"});
        }
    };

    const isTourCompleted = (tour) =>
        cartItems.some(
            item => item.productCode === tour.rezdy_id
        );

    if (!combo) {
        return <div>Loading...</div>;
    }
    const activeIndex = combo.tours.findIndex(
        t => t.tour_id === activeTour?.tour_id
    );
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <Breadcrumb items={breadcrumbItems}/>
                    {/*<script defer="" type="text/javascript" src="https://mightyaussie.rezdy.com/pluginJs"></script>*/}
                    <div className={s.titleContainer}>
                        <h2><img className={s.titleImage} src={titleImage}/>{combo.name}</h2>

                    </div>
                </div>

            </div>
            <div className="row">

                <div className="card mb-4">
                    <div className="card-body">
                        <h2>{combo.name}</h2>

                        <p>{combo.description}</p>

                        {/*{combo.promo_code && (*/}
                        {/*    <div className="alert alert-success">*/}
                        {/*        Promo Code: <strong>{combo.promo_code}</strong>*/}
                        {/*    </div>*/}
                        {/*)}*/}
                    </div>
                </div>

                <div className={s.comboProgress}>
                    <div className={s.progressContainer}>
                        {combo.tours.map((tour, index) => {
                            const completed = isTourCompleted(tour);

                            return (
                                <div
                                    key={tour.tour_id}
                                    className={`
                                            ${s.step}
                                            ${completed ? s.completed : ""}
                                            ${activeTour?.tour_id === tour.tour_id ? s.active : ""}
                                        `}
                                    onClick={() => setActiveTour(tour)}
                                >
                                    <div className={s.circle}>
                                        {completed ? "✓" : index + 1}
                                    </div>

                                    <div className={s.stepLabel}>
                                        Tour {index + 1}
                                    </div>

                                    <div className={s.tourTitle}>
                                        {tour.title}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

                {activeTour && (
                    <TourDetailsNew
                        rezdyId={activeTour.tour_id}
                        isCombo={true}
                        combo={combo}
                        activeTour={activeTour}
                        onComboTourCompleted={handleNextTour}
                    />
                )}
            </div>
        </>
    );
}